import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
    children: React.ReactNode;
    userRole?: number;
}

function ProtectedRoute({ children, userRole = 0 }: ProtectedRouteProps) {
    const { authState, isLoggingOut } = useAuth();
    const location = useLocation();
    const redirectTo = `${location.pathname}${location.search}`;

    if (authState.token === "" || authState.user?.userId == 0) {
        const redirectUri = encodeURIComponent(redirectTo);
        const url =
            redirectTo === "/" || isLoggingOut ? `/login` : `/login?redirect=${redirectUri}`;
        return <Navigate to={url} />;
    }
    if (authState.user?.userRole < userRole) {
        return <Navigate to="/" />;
    }

    return <>{children}</>;
}

export default ProtectedRoute;